import { GetHireJobsFilters } from "./services/job.services";

const EMPTY_FILTERS = {};

export const GO_HIRE_QUERY_KEYS = {
  all: ["go-hire"] as const,

  jobDetails: (id: number | string) => [...GO_HIRE_QUERY_KEYS.all, "job-details", id] as const,

  jobsList: (filters?: GetHireJobsFilters) =>
    [...GO_HIRE_QUERY_KEYS.all, "jobs-list", filters ?? EMPTY_FILTERS] as const,

  topMatchedApplicants: (jobId: number | string) =>
    [...GO_HIRE_QUERY_KEYS.all, "top-matched-applicants", jobId] as const,

  candidates: (jobId: number | string, filters?: any) =>
    [...GO_HIRE_QUERY_KEYS.all, "candidates", jobId, filters ?? EMPTY_FILTERS] as const,

  jobsSummary: (filters?: any) => [...GO_HIRE_QUERY_KEYS.all, "jobs-summary", filters ?? EMPTY_FILTERS] as const,
  talentHeatmap: () => [...GO_HIRE_QUERY_KEYS.all, "talent-heatmap"] as const,

  candidateApplication: (jobId: number | string, candidateId: number | string) =>
    [...GO_HIRE_QUERY_KEYS.all, "candidate-application", jobId, candidateId] as const,

  candidateReview: (jobId: number | string, candidateId: number | string) =>
    [...GO_HIRE_QUERY_KEYS.all, "candidate-review", jobId, candidateId] as const,
};
